export default {
    title: "Nicht gelieferte Artikel",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Danke",
        message: "Vielen Dank für Ihre Antwort."
    },
    message: "Sie haben angegeben, dass Sie Ihren Artikel nicht erhalten haben, obwohl der Kurier ihn als zugestellt markiert hat.",
    cta: "Befolgen Sie diese Schritte, um uns bei der Behebung des Problems zu helfen:",
    items: {
        1: {
            message: "Klicken Sie auf den/die Tracking-Link(s):"
        },
        2: {
            message: "Überprüfen Sie den Lieferstatus. Prüfen Sie Folgendes:",
            items: {
                1: "Wer hat für das Paket unterschrieben?",
                2: "Wenn es an den Absender zurückgeschickt wurde",
                3: "Wenn das Paket zur Abholung wartet"
            }
        },
        3: {
            message: "Suchen Sie nach einer Lieferbenachrichtigung, aus der hervorgeht, wo der Artikel möglicherweise abgelegt wurde."
        },
        4: {
            message: "Fragen Sie bei Nachbarn, Verwandten und Freunden nach, die das Paket möglicherweise mitgenommen haben."
        }
    },
    question: "Konnte Ihre Lieferanfrage dadurch geklärt werden? Haben Sie den Artikel jetzt oder wissen Sie, wer ihn hat? Bitte antworten Sie unten.",
    product: {
        name: "Artikelname",
        quantity: "Menge",
        tracking: "Sendungsverfolgung",
    },
    buttons: {
        yes: "Ja",
        no: "NEIN",
        saving: "Speichern"
    }
}